






















import BaseInput from "../models/base.input";
import { Vue, Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
@Component({
    props: ['cols', 'name', 'value', 'label', 'validate', 'type', 'min', 'max', 'disabled', 'labelCols']
})
export default class Input extends Vue {  

    @Prop()
    name :any;
    @Prop()
    validate :any;   
    @Prop()
    labelCols :any;
    
    lCols : any = this.labelCols ? this.labelCols : 2;
}
